import { render, staticRenderFns } from "./NewsCategoryTabBar.vue?vue&type=template&id=c4e03238&scoped=true&"
import script from "./NewsCategoryTabBar.vue?vue&type=script&lang=js&"
export * from "./NewsCategoryTabBar.vue?vue&type=script&lang=js&"
import style0 from "./NewsCategoryTabBar.vue?vue&type=style&index=0&id=c4e03238&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e03238",
  null
  
)

export default component.exports